<template>
<div id="kosiwon-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="kosiwon-modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="kosiwon-modalLabel">{{ computedKosiwonName(kosiwon) }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-header">
                <h6 class="my-0">요청일 : {{ kosiwon.created }}</h6>
            </div>
            <div class="modal-header" v-if="subMsg">
                <h6 class="my-0 text-danger">거절 사유 : {{ subMsg }}</h6>
            </div>

            <div class="modal-body">
                <!-- 기본 정보 -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <label class="form-label">고시원 이름 <span class="text-danger">*</span></label>
                            <input class="form-control" type="text" id="name" placeholder="고시원 이름을 입력해주세요." v-model="kosiwon.name" readonly />
                            <label class="font-13 text-muted fw-light mt-1">e.g "휴식"</label>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <label class="form-label">지점명</label>
                            <input class="form-control" type="text" id="branch" placeholder="지점명을 입력해주세요." v-model="kosiwon.branch" readonly />
                            <label class="font-13 text-muted fw-light mt-1">e.g "노원 1호점"</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <label class="form-label">원장님 성함 <span class="text-danger">*</span></label>
                            <input class="form-control" type="text" id="owner_name" placeholder="원장님 성함을 입력해주세요." v-model="kosiwon.owner_name" readonly />
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <label class="form-label">사업자 번호 <span class="text-danger">*</span></label>
                            <input class="form-control" type="text" id="company_registration_number" placeholder="사업자 번호를 입력해주세요." v-model="kosiwon.company_registration_number" readonly />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <label class="form-label">주소 <span class="text-danger">*</span></label>
                            <input class="form-control" type="text" id="address_brief" placeholder="클릭하여 주소를 검색해주세요." v-model="kosiwon.address_brief" readonly />
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <label class="form-label">상세 주소 <span class="text-danger">*</span></label>
                            <input class="form-control" type="text" id="address_detail" placeholder="상세 주소를 입력해주세요." v-model="kosiwon.address_detail" readonly />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <div class="row">
                                <div class="col-6">
                                    <label class="form-label">층 수 <span class="text-danger">*</span></label>
                                    <input class="form-control" type="text" id="floor" placeholder="사용중인 고시원 층" v-model="kosiwon.floor" readonly />
                                    <label class="font-13 text-muted fw-light mt-1">e.g "3층" 또는 "3~5층"</label>
                                </div>
                                <div class="col-6">
                                    <label class="form-label">&nbsp;</label>
                                    <input class="form-control" type="text" id="building_floor" placeholder="건물 전체 층" v-model="kosiwon.building_floor" readonly />
                                    <label class="font-13 text-muted fw-light mt-1">e.g "5층"</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <label class="form-label">홈페이지 URL</label>
                            <input class="form-control" type="text" placeholder="홈페이지 URL을 입력해주세요." v-model="kosiwon.url" readonly />
                            <label class="font-13 text-muted fw-light mt-1">e.g "https://kosirock.com"</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <div class="row">
                                <div class="col-6">
                                    <label class="form-label">고시원 대표 번호 <span class="text-danger">*</span></label>
                                    <input class="form-control" type="tel" id="phone_no" placeholder="고시원 대표 번호" v-model="kosiwon.phone_no" readonly />
                                    <label class="font-13 text-muted fw-light mt-1">고시원 대표 번호가 존재하지 않으면 원장님 휴대폰 번호를 입력해주세요.</label>
                                </div>
                                <div class="col-6">
                                    <label class="form-label">&nbsp;</label>
                                    <input class="form-control" type="tel" placeholder="실제 노출 번호" v-model="kosiwon.virtual_no" style="background-color: var(--ct-gray-100);" readonly />
                                    <label class="font-13 text-muted fw-light mt-1">실제 노출 번호는 고시원 등록 후, 자동으로 매핑됩니다.</label>
                                </div>
                            </div>
                        </div>
                        <div class="mb-4">
                            <label class="form-label">원장님 휴대폰 번호 <span class="text-danger">*</span></label>
                            <input class="form-control" type="tel" id="cellphone_no" placeholder="원장님 휴대폰 번호를 입력해주세요." v-model="kosiwon.cellphone_no" readonly />
                        </div>
                        <div class="mb-4">
                            <label class="form-label">고시원 최소/최대 가격 (단위 : 만원) <span class="text-danger">*</span></label>
                            <input type="text" id="price" data-plugin="range-slider" data-min="0" data-max="120" data-from="30" data-to="60" data-type="double" data-grid="true" data-postfix=" 만원" />
                        </div>
                        <div class="mb-4">
                            <label class="form-label">보증금 (단위 : 만원 / 없을 시, 0원) <span class="text-danger">*</span></label>
                            <input type="text" id="deposit" data-plugin="range-slider" data-min="0" data-max="100" data-from="0" data-grid="true" data-postfix=" 만원" />
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <label class="form-label">고시원 한 줄 소개 <span class="text-danger">*</span></label>
                            <input class="form-control" type="text" id="intro" placeholder="고시원 한 줄 소개를 자유롭게 입력해주세요." v-model="kosiwon.intro" readonly />
                            <label class="font-13 text-muted fw-light mt-1">e.g "24 년 6월 오픈! 논현역 도보 5분 프리미엄 레지던스 휴식 논현점 "</label>
                        </div>
                        <div class="mb-4">
                            <label class="form-label">고시원 상세 설명 <span class="text-danger">*</span></label>
                            <textarea class="form-control" id="description" rows="13" v-model="kosiwon.description" readonly></textarea>
                        </div>
                    </div>
                </div>
                <!-- 옵션 -->
                <div class="row">
                    <div class="mb-4">
                        <label class="form-label">고시원 옵션 (다중 선택 가능) <span class="text-danger">*</span></label>
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-outline-info" v-for="(type, idx) in options" :key="`options_${idx}`" :class="{'active' : type.checked}">
                                {{ type.text }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4">
                        <div class="mb-4">
                            <label class="form-label">사용자 구분 <span class="text-danger">*</span></label>
                            <div class="d-flex flex-wrap gap-2">
                                <button type="button" class="btn btn-outline-info" v-for="(type, idx) in useSexType_options" :key="`sex_${idx}`" :class="{'active' : type.checked}">
                                    {{ type.text }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="mb-4">
                            <label class="form-label">난방 타입 <span class="text-danger">*</span></label>
                            <div class="d-flex flex-wrap gap-2">
                                <button type="button" class="btn btn-outline-info" v-for="(type, idx) in heatingType_options" :key="`heating_${idx}`" :class="{'active' : type.checked}">
                                    {{ type.text }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="mb-4">
                            <label class="form-label">룸 타입 (다중 선택 가능) <span class="text-danger">*</span></label>
                            <div class="d-flex flex-wrap gap-2">
                                <button type="button" class="btn btn-outline-info" v-for="(type, idx) in roomType_options" :key="`roomType_${idx}`" :class="{'active' : type.checked}">
                                    {{ type.text }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-show="kosiwon.traffics_subway.filter(item => !item.is_deleted).length > 0">
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <label class="form-label">지하철 정보</label>
                            <div class="row mb-2" v-for="(subway, idx) in kosiwon.traffics_subway.filter(item => !item.is_deleted)" :key="`subway_${idx}`">
                                <div class="col-4">
                                    <select class="form-select" v-model="subway.station_number">
                                        <option value="" disabled selected>호선</option>
                                        <option v-for="line in subwayLine_list" :value="line" disabled>
                                            {{ line }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-8">
                                    <div class="input-group">
                                        <input class="form-control" type="text" placeholder="역 이름을 입력해주세요." v-model="subway.intro" readonly />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div>
                        <label class="form-label">고시원 대표 사진
                            <span class="text-danger">*</span>
                        </label>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col text-center mb-3" v-if="kosiwon.thumbnail_url">
                        <div class="image-container">
                            <img :src="kosiwon.thumbnail_url" class="img-fluid kosiwon-thumbnail-img" alt="Kosiwon Thumbnail Image" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div>
                        <label class="form-label">고시원 사진 정보 (10장 이내)
                            <span class="text-danger">*</span>
                        </label>
                    </div>
                </div>
                <div class="row mb-3" v-if="kosiwon.categories[0].groups[0].images.length > 0">
                    <div class="col-md-3 col-6 text-center mb-3" v-for="(item, idx) in kosiwon.categories[0].groups[0].images" :key="`kosiwon_image_${idx}`">
                        <div class="image-container">
                            <img :src="item.image_url" class="img-fluid kosiwon-info-img" alt="Kosiwon Image" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import common from "@/mixins/common.js";

export default {
    props: ["kosiwon", "subMsg"],
    mixins: [
        common
    ],
    data() {
        return {
            subwayLine_list: [
                "1", "2", "3", "4", "5", "6", "7", "8", "9",
                "인천1", "인천2", "분당", "신분당", "경의중앙", "공항철도",
                "경춘", "의정부", "용인", "경강", "우이신설", "서해",
                "김포골드", "신림"
            ],
            options: [
                // line-1    
                {
                    value: "is_parking",
                    text: "주차장",
                    checked: false
                },
                {
                    value: "is_elevator",
                    text: "엘리베이터",
                    checked: false
                },
                {
                    value: "is_meal",
                    text: "식사 제공",
                    checked: false
                },
                {
                    value: "is_restroom",
                    text: "개별 화장실",
                    checked: false
                },
                {
                    value: "is_kitchen",
                    text: "공용 주방",
                    checked: false
                },

                // line-2
                {
                    value: "is_washroom",
                    text: "공용 세탁기",
                    checked: false
                },
                {
                    value: "is_dry",
                    text: "공용 건조기",
                    checked: false
                },
                {
                    value: "is_cctv",
                    text: "CCTV",
                    checked: false
                },
                {
                    value: "is_double_room",
                    text: "2인실",
                    checked: false
                },
                {
                    value: "is_sprinkler",
                    text: "스프링쿨러",
                    checked: false
                },

                // line-3
                {
                    value: "option_desk",
                    text: "책상",
                    checked: false
                },
                {
                    value: "option_bed",
                    text: "침대",
                    checked: false
                },
                {
                    value: "option_refrigerator",
                    text: "개별 냉장고",
                    checked: false
                },
                {
                    value: "option_fan",
                    text: "선풍기",
                    checked: false
                },
                {
                    value: "option_aircon",
                    text: "개별 에어컨",
                    checked: false
                },

                // line-4
                {
                    value: "option_closet",
                    text: "옷장",
                    checked: false
                },
                {
                    value: "option_wash",
                    text: "개별 세탁기",
                    checked: false
                },
                {
                    value: "option_doorlock",
                    text: "개별 도어락",
                    checked: false
                },
                {
                    value: "option_tv",
                    text: "TV / 모니터",
                    checked: false
                },
                {
                    value: "option_internet",
                    text: "인터넷(WI-FI)",
                    checked: false
                }
            ],
            useSexType_options: [{
                    value: "U",
                    text: "성별 무관",
                    checked: true
                },
                {
                    value: "S",
                    text: "남녀 층 분리",
                    checked: false
                },
                {
                    value: "M",
                    text: "남성 전용",
                    checked: false
                },
                {
                    value: "W",
                    text: "여성 전용",
                    checked: false
                }
            ],

            heatingType_options: [{
                    value: "N",
                    text: "없음",
                    checked: true
                },
                {
                    value: "C",
                    text: "중앙 난방",
                    checked: false
                },
                {
                    value: "S",
                    text: "개별 난방",
                    checked: false
                }
            ],

            roomType_options: [{
                    value: "O",
                    text: "원룸",
                    checked: true
                },
                {
                    value: "S",
                    text: "샤워룸",
                    checked: false
                },
                {
                    value: "M",
                    text: "미니룸",
                    checked: false
                }
            ]
        }
    },
    watch: {
        kosiwon() {
            this.$nextTick(() => {
                this.$store.commit("INIT_RANGE_SLIDER");

                $("#price").data("ionRangeSlider").update({
                    from: this.kosiwon.price_min,
                    to: this.kosiwon.price_max,
                    disable: true
                });
                $("#deposit").data("ionRangeSlider").update({
                    from: this.kosiwon.deposit || 0,
                    disable: true
                });

                // * 옵션 값 셋팅
                this.options.forEach(option => option.checked = this.kosiwon.options[option.value]);

                // * 사용자 구분 값 셋팅
                this.useSexType_options.forEach(option => option.checked = (option.value === this.kosiwon.options.use_sex_type));

                // * 난방 타입 셋팅
                this.heatingType_options.forEach(option => option.checked = (option.value === this.kosiwon.heating_type));

                // * 룸 타입 셋팅 (다중 선택)
                const roomArray = this.kosiwon.room_type.split(",");
                this.roomType_options.forEach(option => {
                    option.checked = roomArray.includes(option.value);
                });
            });
        },
    },
    methods: {
        computedKosiwonName(kosiwon) {
            return `${kosiwon.name} ${kosiwon.branch}`;
        }
    }
}
</script>

<style>
#kosiwon-modal table,
#kosiwon-modal img {
    width: 100% !important;
}

.custom-btn-5 {
    width: calc(100%/5 - 10px);
}

.custom-btn-4 {
    width: calc(100%/4 - 10px);
}

.custom-btn-3 {
    width: calc(100%/3 - 10px);
}

.avatar-title-custom {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid lightgray;
    background: none;
    opacity: 0.5;
}

.avatar-title-custom:hover {
    opacity: 1;
}

.avatar-title-custom i {
    display: block;
    margin-bottom: 5px;
    /* 아이콘과 텍스트 사이의 간격 */
}

.kosiwon-thumbnail-img {
    max-height: 400px;
    border: 1px solid lightgray;
}

.kosiwon-info-img {
    max-height: 200px;
    border: 1px solid lightgray;
}

.kosiwon-info-img-swap {
    position: absolute;
    top: 10px;
    left: 10px;
    font-size: 20px;
    color: gray;
}
</style>
